import React from "react";
import { func } from "prop-types";
import { useSelector } from "react-redux";
import { selectImageStatus } from "redux/image/selectors";
import { selectAllowStatusesByStatus } from "redux/permission/selector";
import ExportSegmentation from "components/ExportSegmentation";
import IntlMessage from "../../helpers/IntlMessage";

import style from "./style.module.scss";
import statusStyle from "../style.module.scss";

/**
 * Mapping from allowed status (API response) to button config.
 * - action: the `data-content` value used by Dialog to determine the action
 * - labelId: IntlMessage id for the button label
 * - className: CSS class for styling
 */
const STATUS_BUTTON_CONFIG = {
  /*
    new: {
        labelId: "common.new",
        className: statusStyle.status_new,
    },
    assigned: {
        labelId: "common.assigned",
        className: statusStyle.status_assigned,
    },
    */
  in_review: {
    labelId: "common.in_review",
    className: statusStyle.status_in_review,
  },
  in_admin_review: {
    labelId: "common.in_admin_review",
    className: statusStyle.status_in_admin_review,
  },
  submitted: {
    labelId: "common.submit",
    className: statusStyle.status_submitted,
  },
  approved: {
    labelId: "common.approve",
    className: statusStyle.status_approved,
  },
  doublecheck: {
    labelId: "common.doublecheck",
    className: statusStyle.status_doublecheck,
  },
  reopen: {
    labelId: "common.reopen",
    className: statusStyle.status_reopen,
  },
  reopened_reviewer: {
    labelId: "common.reopened_reviewer",
    className: statusStyle.status_reopened_reviewer,
  },
  declined: {
    labelId: "common.decline",
    className: statusStyle.status_declined,
  },
  skipped: {
    labelId: "common.skip",
    className: statusStyle.status_skipped,
  },
};

function ButtonGroupV2({ handleOpenDialog }) {
  const imageStatus = useSelector(selectImageStatus);
  const allowedStatuses = useSelector(selectAllowStatusesByStatus(imageStatus));

  return (
    <div className={style.buttonGroupContainer}>
      {Array.isArray(allowedStatuses) &&
        allowedStatuses.map((status) => {
          const config = STATUS_BUTTON_CONFIG[status];
          if (!config) return null;

          return (
            <button
              key={status}
              className={`${style.actionButton} ${config.className}`}
              data-content={status}
              onClick={handleOpenDialog}
            >
              <IntlMessage id={config.labelId} />
            </button>
          );
        })}
      <ExportSegmentation
        classList={`${style.actionButton} ${style.exportImageButton}`}
      />
    </div>
  );
}

ButtonGroupV2.propTypes = {
  handleOpenDialog: func,
};

export default ButtonGroupV2;
